/* eslint-disable @typescript-eslint/indent */

/* Note: please be careful with indentation, we have the rule disabled because of
*  eslint not being able to properly indent js inside styled components
*/

// Libraries
import styled from 'styled-components';

// Plugins
import { getSeriesThemeColor } from '../../../plugins/trendings';

export const SeriesChipRoot = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 0.25rem 0.5rem;
  border-radius: 16px;
  font-size: 12px;
  white-space: nowrap;
  font-family: ${({ theme }) => theme.font.regular};
  color: ${({ theme }) => theme.color.tag.neutralTypeTextColor};
  background-color: ${({ theme }) => theme.color.tag.neutralTypeBackgroundColor};
`;

export const SeriesChipColorDot = styled.span<{ color: string }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  border-radius: 3px;
  background-color: ${({ color, theme }) => getSeriesThemeColor(color, theme)};
  flex-shrink: 0;
  color: ${({ theme }) => theme.color.checkbox.checkedIconColor};
  font-size: 11px;
`;

export const SeriesChipClose = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: none;
  cursor: pointer;
  font-size: 10px;
  padding: 0.125rem;
  min-width: 16px;
  min-height: 16px;
  border-radius: 50%;
  position: relative;
  color: ${({ theme }) => theme.color.tag.neutralTypeTextColor};

  /* Expand touch target to 32x32px without changing visual size */
  &::after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 32px;
    height: 32px;
  };

  &:hover {
    opacity: 0.7;
  };
`;
